import Bullet from 'components/prism/bullet';
import React from 'react';

export const Recommended = ({ data, multiColumn }) => {
    const toggleFlag = () => {
        console.log('TOGGLED FLAG');
    };

    return (
        <>
            <h2 className="mb10">Recommended for you</h2>
            <div className="mb10">
                Capability reviews and your manager help to highlight the exact behaviours that will drive your performance
                forward.
            </div>
            <div className={multiColumn ? 'even-col' : ''}>
                {data.map(item => (
                    <div
                        key={`recommended-${item.id}`}
                        className={`prism-content-box anchor-top ${multiColumn ? '' : 'mb10'}`}
                    >
                        <div className="prism-banner-float flex flex-center">
                            <Bullet type="behavior" />
                            <div className="flex-grow text-right">
                                <button className="btn" onClick={toggleFlag}>
                                    <i className={`fa fa-flag ${item.flagged ? 'fa-solid' : ''}`} />
                                </button>
                            </div>
                        </div>
                        <div className="prism-banner">
                            <img src={item.image} />
                        </div>
                        <div className="prism-content">
                            <h3>{item.name}</h3>
                            {item.description && <p>{item.description}</p>}
                            <a href="#">{item.courseCount} course(s)</a> &bull;{' '}
                            <a href="#">Related to {item.metricCount} Metric(s)</a>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Recommended;
